// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"359":"form_aula","535":"login","669":"aulas"}[chunkId] + "." + {"359":"a999f8ae","535":"462ab56e","669":"ed2d88a8"}[chunkId] + ".js";
};